const filterItemFunc = () => {
    const filtersBlock = document.querySelector('.filters');
    if (!filtersBlock) return;

    const filterItems = filtersBlock.querySelectorAll('.filter-group');

    filterItems.forEach(item => {
        const inputHolder = item.querySelector('.input-holder');
        const subItemHolder = item.querySelector('.sub-item-holder');

        if (!inputHolder || !subItemHolder) return;

        item.addEventListener('click', function (event) {
            event.stopPropagation();

            const isActive = inputHolder.classList.contains('active');

            closeAllFilters();

            if (!isActive) {
                inputHolder.classList.add('active');
                subItemHolder.classList.add('show');
            }
        });
    });

    document.addEventListener('click', function () {
        closeAllFilters();
    });

    function closeAllFilters() {
        filterItems.forEach(item => {
            const inputHolder = item.querySelector('.input-holder');
            const subItemHolder = item.querySelector('.sub-item-holder');
            if (inputHolder) inputHolder.classList.remove('active');
            if (subItemHolder) subItemHolder.classList.remove('show');
        });
    }
};

export default filterItemFunc;